// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProToolBox_wrapper__TBJ_S"};